import React, { useState } from "react";
import { Container } from "react-smooth-dnd";

const DropZoneContainer = (props) => {
  const {
    children,
    onDrop = () => {},
    onDragLeave = () => {},
    onDragEnter = () => {},
  } = props;
  const [isHoverActive, setIsHoverActive] = useState(false);

  return (
    <Container
      {...props}
      getGhostParent={() => document.body}
      style={{
        ...props.style,
        border: isHoverActive ? "2px solid #096DD9" : "2px solid transparent",
        borderRadius: "4px",
        overflow: "auto",
        overflowX: "hidden",
      }}
      onDragLeave={() => {
        if (isHoverActive) setIsHoverActive(false);

        onDragLeave();
      }}
      onDragEnter={() => {
        if (!isHoverActive) setIsHoverActive(true);
        onDragEnter();
      }}
      onDrop={(dropResult) => {
        setIsHoverActive(false);
        onDrop(dropResult);
      }}
    >
      {children}
    </Container>
  );
};

export default DropZoneContainer;
